import React, { FC } from 'react';
import { CellRendererParams } from './types';

export const RoleRenderer: FC<CellRendererParams> = ({ value }) => {
  return <>{value?.roleName ?? '-'}</>;
};
